import React from 'react';
import { useSelector } from 'react-redux';
import { Tab, TabList, TabPanel, Tabs } from '../../CommonComponents/OPL/Tab';
import {
  ASSET_BUCKETING,
  ASSET_CLASSES,
  CUSTOM_MODEL_ASSUMPTIONS,
  FIRM_SETTINGS_OPTION,
  INTEGRATIONS_OPTION,
  MENU_OPTIONS,
  MODELS_OPTION,
} from '../AdviserSettingsConst';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { useFeatureFlag } from '../../_hooks/useFeatureFlag';
import { Feature } from '../../CommonSelectors/CommonArea.types';
import { selectHasAdvisorAssetBucketingLayoutAccess } from '../../AdviserArea/AdviserAreaSelector';

interface Props {
  currentPageId: null | number;
  firmSettingsAccess: boolean;
  showAssetClassMapping: boolean;
  showFinancialPlanning: boolean;
  hasAssetBucketingFirm: boolean;
}

const SettingsMenu: React.FC<Props> = ({
  currentPageId = null,
  firmSettingsAccess,
  showAssetClassMapping,
  showFinancialPlanning,
  children,
  hasAssetBucketingFirm,
}) => {
  const showAssetBucketingTab = useFeatureFlag(Feature.AssetBucketingTab);

  const hasAdvisorAssetBucketingLayoutAccess = useSelector(
    selectHasAdvisorAssetBucketingLayoutAccess,
  );

  const menuOptions = MENU_OPTIONS.filter(({ id }) => {
    switch (id) {
      case FIRM_SETTINGS_OPTION:
        return firmSettingsAccess;
      case INTEGRATIONS_OPTION:
        return showFinancialPlanning;
      case MODELS_OPTION:
        return firmSettingsAccess && showFinancialPlanning;
      case ASSET_CLASSES:
        return showAssetClassMapping && firmSettingsAccess && showFinancialPlanning;
      case CUSTOM_MODEL_ASSUMPTIONS:
        return firmSettingsAccess && showFinancialPlanning;
      case ASSET_BUCKETING:
        return (
          (firmSettingsAccess && hasAssetBucketingFirm && showAssetBucketingTab) ||
          hasAdvisorAssetBucketingLayoutAccess
        );
      default:
        return true;
    }
  });

  const selectedIndex = menuOptions.findIndex(({ id }) => currentPageId === id) || 0;

  return (
    <Tabs
      mt="32"
      selectedIndex={selectedIndex}
      onSelect={index => {
        ADV.util.Router.go2('AdviserSettings', { page: menuOptions[index].slug });
      }}
    >
      <TabList>
        {menuOptions.map(({ id, name }) => (
          <Tab key={id}>{name}</Tab>
        ))}
      </TabList>

      {menuOptions.map(({ id }, index) => {
        return (
          <TabPanel key={id}>{index === selectedIndex && <Box mt="24">{children}</Box>}</TabPanel>
        );
      })}
    </Tabs>
  );
};

export default SettingsMenu;
